jQuery(document).ready(function($){
  
  $('.js-load-more').on('click', function(){
    var $this =$(this),
        totalPages = parseInt($('[data-all-pages]').val()),
        currentPage = parseInt($('[data-this-page]').val()),
        datacollurl = $('[data-coll-url]').val();;
    $this.attr('disabled', true);
    $this.find('[load-more-text]').addClass('hide');
    $this.find('[loader]').removeClass('hide');
    var nextUrl = $('[data-next-link]').val();
    var current_page_new = currentPage + 1;
    var next_coll = currentPage + 2;
    
    $.ajax({
      url: nextUrl,
      type: 'GET',
      dataType: 'html',
      success: function(responseHTML){
        $('[data-next-link]').val(datacollurl + "?page="+next_coll);
        $('[data-this-page]').val(current_page_new);
        $('.collection-products.uniform-layout').append($(responseHTML).find('.collection-products.uniform-layout').html());
      },
      complete: function() {
        if(current_page_new < totalPages) {
          $this.attr('disabled', false); $this.find('[load-more-text]').removeClass('hide'); $this.find('[loader]').addClass('hide');
        } 
        if(current_page_new >= totalPages) {
          $this.find('[load-more-text]').text('All Products Loaded').removeClass('hide'); $this.find('[loader]').addClass('hide');
        } 
      }
    })
  });

  /*$(window).on('scroll', function() {
    if($('.section-collections-list .js-load-more').length) {
      if($(window).scrollTop() + $(window).height() == $(document).height()) {
         $('.section-collections-list .js-load-more').click();
      }
    }
  });*/
  
  $('.section-collections-list .js-load-more').on('click', function(){
    var $this =$(this),
        totalPages = parseInt($('[data-all-pages]').val()),
        currentPage = parseInt($('[data-this-page]').val()),
        datacollurl = $('[data-coll-url]').val();;
    $this.attr('disabled', true);
    $this.find('[load-more-text]').addClass('hide');
    $this.find('[loader]').removeClass('hide');
    var nextUrl = $('[data-next-link]').val();
    var current_page_new = currentPage + 1;
    var next_coll = currentPage + 2;
    
    $.ajax({
      url: nextUrl,
      type: 'GET',
      dataType: 'html',
      success: function(responseHTML){
        $('[data-next-link]').val(datacollurl + "?page="+next_coll);
        $('[data-this-page]').val(current_page_new);
        $('.collections-list').append($(responseHTML).find('.collections-list').html());
      },
      complete: function() {
        if(current_page_new < totalPages) {
          $this.attr('disabled', false); $this.find('[load-more-text]').removeClass('hide'); $this.find('[loader]').addClass('hide');
        } 
        if(current_page_new >= totalPages) {
          $this.find('[load-more-text]').text('All Products Loaded').removeClass('hide'); $this.find('[loader]').addClass('hide');
        } 
      }
    })
  });

});